<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Retours</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
        <input type="date" v-model="form.from_date" class="border border-gray-200 p-2"/>
        <input type="date" v-model="form.to_date" class="border border-gray-200 p-2"/>
        <loading-button :loading="sending" class="btn-indigo ml-1" type="submit" @click.native="exportReturns">Exporter</loading-button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">N° Order</th>
          <th class="px-6 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Date de reception</th>
        </tr>
        <tr v-for="product in products.data" :key="product.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('return.detail', product.id)" tabindex="-1">
              {{ product.repair_id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('return.detail', product.id)" tabindex="-1">
            {{ product.imei }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('return.detail', product.id)" tabindex="-1">
            {{ product.created_at }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="products.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No swap found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="products.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Retours' },
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    LoadingButton,
  },
  props: {
    products: Object,
    filters: Object,
  },
  data() {
    return {
      sending: false,
      form: {
        search: this.filters.search,
        from_date: this.filters.from_date,
        to_date: this.filters.to_date,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('return.list', Object.keys(query).length ? query : { remember: 'forget' }),{
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    exportReturns() {
     if (this.form.from_date !== undefined && this.form.to_date !== undefined) {
       window.open(this.route('return.exportReturns', [this.form.from_date, this.form.to_date]), "_blank");
     }else {
       alert("please fill dates")
     }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
